module.exports = __webpack_public_path__ + "img/5.180f74fc.png";